<app-view #view [code]="'sectors.edit'" [model]="sector" (onEvent)="onEvent($event)"></app-view>